import { cn } from '@/utils'
import markLight from '@/assets/brand/mark-light.svg'
import markDark from '@/assets/brand/mark-dark.svg'

type LogoSize = 'sm' | 'md' | 'lg' | 'xl'

const SIZES: Record<LogoSize, string> = {
  sm: 'h-7 w-7',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
}

/**
 * The Vharta "V" mark on its own — the companion to `Wordmark`, which is the
 * full lockup. Used where the lockup cannot fit: the collapsed 64px sidebar
 * rail, and the auth pages that still lead with a mark rather than a lockup.
 *
 * Two transparent assets swapped on the app theme: the blue mark (#1C4C6E)
 * for light surfaces, the amber (#D9963C) for dark ones — the same pairing
 * the wordmark uses.
 *
 * No badge chrome. These replaced opaque square tiles that needed a rounded
 * crop and a hairline ring to read as a badge against a same-coloured
 * surface; the tight marks are transparent, so a ring would just draw a box
 * around the glyph's empty corners. `object-contain` inside the square box
 * keeps the slightly-taller-than-wide mark (216x238) undistorted.
 */
export function Logo({ size = 'md', className }: { size?: LogoSize; className?: string }) {
  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center', SIZES[size], className)}>
      {/* Light mode: blue mark */}
      <img
        src={markLight}
        alt="Vharta"
        className="block h-full w-full object-contain dark:hidden"
        draggable={false}
      />
      {/* Dark mode: amber mark */}
      <img
        src={markDark}
        alt=""
        aria-hidden="true"
        className="hidden h-full w-full object-contain dark:block"
        draggable={false}
      />
    </span>
  )
}
